export const createIDRCase = /* GraphQL */ `
  mutation CreateIDRCase($input: CreateIDRCaseInput!) {
    createIDRCase(input: $input) {
      id
      userId
      caseName
      storageIdentityId
      processingStatus
      workflowJson
      manifestJson
      draftMarkdown
      artifactVersion
      analysisRunId
      analysisArtifactVersion
      analysisRunStatus
      analysisStatusJson
      clinicalAnalysisJson
      pricingAnalysisJson
      legalResearchJson
      createdAt
      updatedAt
    }
  }
`;

export const updateIDRCase = /* GraphQL */ `
  mutation UpdateIDRCase(
    $input: UpdateIDRCaseInput!
    $condition: ModelIDRCaseConditionInput
  ) {
    updateIDRCase(input: $input, condition: $condition) {
      id
      userId
      caseName
      storageIdentityId
      processingStatus
      workflowJson
      manifestJson
      draftMarkdown
      artifactVersion
      analysisRunId
      analysisArtifactVersion
      analysisRunStatus
      analysisStatusJson
      clinicalAnalysisJson
      pricingAnalysisJson
      legalResearchJson
      createdAt
      updatedAt
    }
  }
`;

export const listIDRCases = /* GraphQL */ `
  query ListIDRCases(
    $filter: ModelIDRCaseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listIDRCases(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userId
        caseName
        storageIdentityId
        processingStatus
        workflowJson
        manifestJson
        draftMarkdown
        artifactVersion
        analysisRunId
        analysisArtifactVersion
        analysisRunStatus
        analysisStatusJson
        clinicalAnalysisJson
        pricingAnalysisJson
        legalResearchJson
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const listIDRAnalysisRunsByCase = /* GraphQL */ `
  query ListIDRAnalysisRunsByCase(
    $caseId: ID!
    $sortDirection: ModelSortDirection
    $limit: Int
    $nextToken: String
  ) {
    listIDRAnalysisRunsByCase(
      caseId: $caseId
      sortDirection: $sortDirection
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        caseId
        runId
        artifactVersion
        inputHash
        schemaVersion
        status
        statusJson
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const getIDRAnalysisRun = /* GraphQL */ `
  query GetIDRAnalysisRun($id: ID!) {
    getIDRAnalysisRun(id: $id) {
      id
      caseId
      runId
      artifactVersion
      inputHash
      schemaVersion
      workflowSnapshotJson
      manifestSnapshotJson
      status
      statusJson
      clinicalAnalysisJson
      pricingAnalysisJson
      legalResearchJson
      createdAt
      updatedAt
    }
  }
`;

export const getIDRApproval = /* GraphQL */ `
  query GetIDRApproval($id: ID!) {
    getIDRApproval(id: $id) {
      id
      userId
      caseId
      artifactVersion
      inputHash
      draftHash
      status
      approvedBy
      approvedAt
      analysisRunId
      analysisRunStatus
      schemaVersion
      attestation
      createdAt
      updatedAt
    }
  }
`;

export const getDocumentExportApproval = /* GraphQL */ `
  query GetDocumentExportApproval($id: ID!) {
    getDocumentExportApproval(id: $id) {
      id
      userId
      subjectType
      subjectId
      artifactVersion
      contentHash
      inputHash
      status
      approvedBy
      approvedAt
      analysisRunId
      schemaVersion
      attestation
      createdAt
      updatedAt
    }
  }
`;
